import React from 'react';
import { Code, TrendingUp, Share2, Target, Palette, Server } from 'lucide-react';
import { services } from '../../mock';

const iconMap = {
  Code, TrendingUp, Share2, Target, Palette, Server
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 px-6 bg-[#1A1430]/30">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center mb-16">What I do</h2>
        
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            
            return (
              <div
                key={service.id}
                className="bg-[#1A1430] border border-[#7C3AED]/10 rounded-2xl p-6 hover:border-[#7C3AED]/30 hover:-translate-y-1 transition-all duration-300 group"
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-full bg-[#7C3AED]/10 flex items-center justify-center mb-5 group-hover:bg-[#7C3AED]/20 transition-colors">
                  {Icon && <Icon size={24} className="text-[#7C3AED]" />}
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-semibold text-[#EDE9FE] mb-3" style={{ fontFamily: 'Geist, Inter, sans-serif' }}>
                  {service.title}
                </h3>
                
                {/* Description */}
                <p className="text-[#9D97B5] leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
